import { useMutation, useQueryClient } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrorsAndJSON } from 'utils/handle-errors'
import { organizationsKeys } from 'utils/query-keys'
import toast from 'react-hot-toast'

interface DisableIntegrationConnectionParams {
  integrationConnectionId: number
  organizationId: string
}

const disableIntegrationConnection = async ({
  integrationConnectionId,
}: DisableIntegrationConnectionParams) => {
  const response = await fetch(
    `${BASE_API_URL}/api/v2/integration_connections/${integrationConnectionId}`,
    {
      method: API_METHODS.PATCH,
      headers: apiHeaders(store.getState()),
      body: JSON.stringify({ status: 'DISABLED' }),
    }
  )
  return handleErrorsAndJSON(response)
}

const useDisableIntegrationConnection = () => {
  const queryClient = useQueryClient()

  return useMutation(
    (params: DisableIntegrationConnectionParams) =>
      disableIntegrationConnection(params),
    {
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries(
          organizationsKeys.integrationConnections.index(
            variables.organizationId
          )
        )
        queryClient.invalidateQueries(
          organizationsKeys.integrations(variables.organizationId)
        )
        toast.success('Integration connection disabled')
      },
      onError: (error: any) => {
        console.error('Disable integration connection error:', error)

        const errorMessage =
          error.message ||
          error?.error?.messages?.[0] ||
          'Failed to disable integration connection.'

        toast.error(errorMessage)
      },
    }
  )
}

export default useDisableIntegrationConnection
